import React from 'react'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'
import Link from 'components/link'
import { storePath } from 'lib/urls'
import * as css from './registry-discount.scss'
import { SectionHeading, StyledSubHeading } from '../../components/headings'

const RegistryDiscount = () => (
  <div>
    <div className={classNames('mbxl', css.heroWrapper)}>
      <div className={css.heroImage} />
    </div>
    <div className="container">
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          <SectionHeading className="text-center mtn mbl">
            {`${BLConstants.CONFIG.store.registryDiscountPctDisplay} Registry Discount`}
          </SectionHeading>

          <p style={{ marginBottom: '70px' }} className="text-center">
            {`We want to make sure you get everything you need off your registry, so you're ready for your baby's arrival. 60 days before their child's arrival date, Babylist users will receive a one-time ${BLConstants.CONFIG.store.registryDiscountPctDisplay} discount on items that are `}
            <Link url={storePath}>sold by Babylist.com</Link>.
          </p>

          <StyledSubHeading>
            <strong>When will I receive my discount?</strong>
          </StyledSubHeading>
          <p className="mbxl">
            {`You will be eligible for your ${BLConstants.CONFIG.store.registryDiscountPctDisplay} registry discount 60 days before your baby's expected arrival date. A link to redeem the discount will be displayed on your registry once you are eligible. Please note if your registry was created less than 30 days ago, you will not yet be eligible.`}
          </p>

          <StyledSubHeading>
            <strong>When can I use my discount?</strong>
          </StyledSubHeading>
          <p className="mbxl">
            You can use your discount for up to 6 months after your baby's
            expected arrival date.
          </p>

          <StyledSubHeading>
            <strong>Does my discount apply to any purchase?</strong>
          </StyledSubHeading>
          <p className="mbxl">
            {`Babylist lets you add items from many stores to one registry. `}
            <strong>
              The Babylist registry discount only applies to items sold by
              Babylist.com.
            </strong>
            {` You can make a one-time purchase of items sold by Babylist, whether
            they are on your Babylist registry or not.`}
          </p>

          <p>
            <strong>
              The registry discount expires 6 months after your baby's expected
              arrival date.
            </strong>
            {` ${BLConstants.CONFIG.store.registryDiscountExclusionsText}`}
          </p>
          <div className="pvxl" />

          <hr className="mvxl" />

          <div className="h7 mbm">
            <strong>Terms and Conditions:</strong>
          </div>
          <ol className={css.termsList}>
            <li>
              The Registry Discount begins 60 days prior to the Expected Arrival
              Date you entered in your Baby Registry and expires 180 days after
              the Expected Arrival Date. Babylist reserves the right to cancel
              the Registry Discount at any time.
            </li>
            <li>
              The Registry Discount may be used only one time for one order.
            </li>
            <li>
              The Registry Discount applies only to items sold by Babylist.com.
              It cannot be used on items at other stores or websites.
            </li>
            <li>
              Items sold and fulfilled by Babylist.com can only be shipped to
              addresses within the US (including APO/DPO/FPOs and PO boxes).
              Some exclusions apply.
            </li>
            <li>
              The Registry Discount may only be redeemed through the Babylist
              account of the primary registrant.
            </li>
            <li>
              If you return any of the items purchased using the Registry
              Discount, we will subtract the value of Registry Discount from
              your return credit.
            </li>
            <li>Void where prohibited.</li>
            <li>This promotion may not be combined with other offers.</li>
            <li>
              Your registry must be active for at least 30 days before you are
              eligible.
            </li>
          </ol>

          <div className="pvxl" />
        </Col>
      </Row>
    </div>
  </div>
)

export default RegistryDiscount
